module.exports = __webpack_public_path__ + "static/media/hotel2.9849bd5d.jpg";